// src/admin/components/SignedImage.tsx
import { useEffect, useState } from 'react';
import { getSignedDocUrl } from '@admin/lib/storage';

interface Props {
  bucket: 'kyc' | 'doc';
  path: string | null | undefined;
  target_type: 'kyc' | 'loan' | 'borrower';
  target_id: string;
  alt: string;
  onClick?: (url: string) => void;
  className?: string;
}
export default function SignedImage({ bucket, path, target_type, target_id, alt, onClick, className }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    void (async () => {
      const r = await getSignedDocUrl({ bucket, path, target_type, target_id });
      if (cancelled) return;
      if ('error' in r) setErr(r.error); else setUrl(r.url);
    })();
    return () => { cancelled = true; };
  }, [bucket, path, target_type, target_id]);

  if (!path) return <span className="small">No image</span>;
  if (err) return <span className="small" style={{ color: 'var(--c-danger)' }}>{err}</span>;
  if (!url) return <span className="small">Loading…</span>;
  return (
    <img
      src={url} alt={alt} className={className}
      onClick={onClick ? () => onClick(url) : undefined}
      style={{ cursor: onClick ? 'zoom-in' : 'default', borderRadius: 8, border: '1px solid var(--c-border)' }}
    />
  );
}
